export default "__VITE_ASSET__upp5by2d__"